import { Routes } from 'react-router-dom'
import { AppRouterItem } from 'ict24h-themes-react/lib/esm/modules/routers/AppRouters'
import mapRouterHelper from '../../utils/MapRouterHelper'
import { DAT_PHONG_HOP_SHORT_PREFIX_URL } from './constants/config.dat-phong-hop'
import PhieuDatPhongHopRouter from './modules/phieu-dat-phong-hop/PhieuDatPhongHopRouter'
import PhongHopRouter from './modules/phong-hop/PhongHopRouter'
import ThietBiPhongHopRouter from './modules/thiet-bi-phong-hop/ThietBiPhongHopRouter'
import AdminPhongHopRouters from './modules/admin-phong-hop/AdminPhongHop.Routers'

const DatPhongHopRouters: AppRouterItem[] = [
  {
    path: `${DAT_PHONG_HOP_SHORT_PREFIX_URL}/*`,
    element: (
      <Routes>
        {mapRouterHelper(PhieuDatPhongHopRouter)}
        {mapRouterHelper(PhongHopRouter)}
        {mapRouterHelper(ThietBiPhongHopRouter)}
        {mapRouterHelper(AdminPhongHopRouters)}
      </Routes>
    ),
  },
]

export default DatPhongHopRouters
